export enum NoticeType {
  INFORMATION = 1,
  WARNING = 2,
  ALERT = 3
}
